// ADV-282: browser page translation (Edge's built-in translator, Chrome/Google Translate, Safari)
// replaces or moves the text nodes React rendered. React still holds the original nodes, so its
// next removeChild/insertBefore on them throws NotFoundError ("The node to be removed is not a
// child of this node", Safari: "The object can not be found here.") and the error boundary
// replaces the page (facebook/react#11538). ~70% of fe-main's Sentry errors, mostly translated
// SRP/VDP visits from outside Germany.
//
// Patch the two DOM methods to skip the operation when the node is no longer where React
// expects it, instead of throwing. The node was already detached or re-parented by the
// translator, so there is nothing sensible left to do with it. Must run before React's first
// commit, so it is imported at the top of index.tsx.
if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function removeChild(child) {
        if (child.parentNode !== this) {
            console.warn('[dom] removeChild skipped: node is no longer a child of this parent (page translated?)');
            return child;
        }
        return originalRemoveChild.call(this, child);
    };
    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            console.warn('[dom] insertBefore skipped: reference node is no longer a child of this parent (page translated?)');
            return newNode;
        }
        return originalInsertBefore.call(this, newNode, referenceNode);
    };
}
export {};
